document.addEventListener('DOMContentLoaded', () => {
  const updateOrientationClasses = () => {
    const isLandscape =
      (window.screen.orientation &&
        window.screen.orientation.type.startsWith('landscape')) ||
      window.matchMedia('(orientation: landscape)').matches ||
      Math.abs(window.orientation || 0) === 90;

    const apply = (selector, on) => {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.toggle('landscape', on);
      });
    };

    apply('.quick-buy-modal', isLandscape);
    apply('.added_to_cart', isLandscape);
  };

  updateOrientationClasses();

  window.addEventListener('orientationchange', updateOrientationClasses);
  window.addEventListener('resize', updateOrientationClasses);
  if (
    window.screen &&
    window.screen.orientation &&
    typeof window.screen.orientation.addEventListener === 'function'
  ) {
    window.screen.orientation.addEventListener(
      'change',
      updateOrientationClasses
    );
  }

  const sortValueEl = document.getElementById('sort-value');

  const getCheckedSortRadio = () =>
    document.querySelector(
      '#FacetFiltersForm input[type="radio"][name="sort_by"]:checked'
    );

  const checkedRadio = getCheckedSortRadio();
  if (sortValueEl && checkedRadio) {
    sortValueEl.classList.remove('skeleton');
    sortValueEl.value = checkedRadio.value;
  }

  document.addEventListener('change', event => {
    const target = event.target;
    if (!target || target.id !== 'sort-value') return;
    const radio = document.querySelector(
      `#FacetFiltersForm input[type="radio"][name="sort_by"][value="${CSS.escape(target.value)}"]`
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  const collectionHandle = document.getElementById('ProductGridContainer')
    .dataset.handleCollection;
  if (
    window.innerWidth <= 991 &&
    (collectionHandle === 'dance-collection' ||
      collectionHandle === 'dusty-shades-collection')
  ) {
    const titleEl = document.querySelector('.section-title');
    if (titleEl) {
      const full = (titleEl.textContent || '').trim();
      const lastSpace = full.lastIndexOf(' ');
      if (lastSpace !== -1) {
        titleEl.textContent = full.substring(0, lastSpace);
      }
    }
  }
});
